module.exports = __webpack_public_path__ + "static/img/nr1-18.497e97e.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/nr1-18.png
// module id = 698
// module chunks = 0